import React from 'react';
import ResourceLayout from './ResourceLayout';

const EngagementChecklist = () => {
  const content = (
    <div className="space-y-8 print:space-y-6">
      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Pre-Course Engagement Strategies</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:gap-4">
          <div className="space-y-4 print:space-y-3">
            <h3 className="font-semibold text-lg text-primary mb-3 print:text-black">Course Setup</h3>
            <div className="space-y-3 print:space-y-2">
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Send welcome email with course overview and expectations</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Provide pre-course survey to assess participant needs</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Share preparatory materials or readings</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Create anticipation with "coming soon" teasers</span>
              </div>
            </div>
          </div>
          <div className="space-y-4 print:space-y-3">
            <h3 className="font-semibold text-lg text-primary mb-3 print:text-black">Environment Preparation</h3>
            <div className="space-y-3 print:space-y-2">
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Set up physical/virtual space for interaction</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Test all technology and backup systems</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Prepare materials and resources in accessible formats</span>
              </div>
              <div className="flex items-start space-x-3 print:space-x-2">
                <input type="checkbox" className="mt-1 text-primary print:text-black" />
                <span className="text-sm print:text-black">Plan seating/breakout arrangements for collaboration</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Opening Session Engagement</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Icebreakers & Introductions</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Use engaging icebreaker appropriate to group size</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Facilitate meaningful introductions beyond names</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Create name tags or virtual identifiers</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Establish communication norms and expectations</span>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Goal Setting</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Review course objectives with participants</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Have participants share personal learning goals</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Connect content to participants' real-world contexts</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Create shared success criteria</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">During Course Engagement Strategies</h2>
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="space-y-4">
              <h3 className="font-semibold text-lg text-primary mb-3">Active Participation</h3>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Use think-pair-share activities</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Rotate speaking opportunities</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Use polling and voting tools</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Incorporate movement and kinesthetic activities</span>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <h3 className="font-semibold text-lg text-primary mb-3">Variety in Delivery</h3>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Mix presentation with interactive segments</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Use multimedia and visual aids</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Include storytelling and real examples</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Vary group sizes (individual, pairs, small/large groups)</span>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <h3 className="font-semibold text-lg text-primary mb-3">Check-ins & Feedback</h3>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Regular temperature checks</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Mid-session feedback collection</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Address questions and concerns promptly</span>
                </div>
                <div className="flex items-start space-x-3">
                  <input type="checkbox" className="mt-1 text-primary" />
                  <span className="text-sm">Provide immediate positive reinforcement</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Technology-Enhanced Engagement</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Digital Tools</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Interactive whiteboards or collaborative documents</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Breakout rooms for small group work</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Screen annotation and highlighting tools</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Chat functions for questions and comments</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Virtual hand-raising and reaction features</span>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Gamification Elements</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Points or badges for participation</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Friendly competition between teams</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Progress tracking and milestones</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Interactive quizzes and challenges</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Recognition and celebration of achievements</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Closing & Follow-up Engagement</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Session Wrap-up</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Summarize key learning points</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Connect back to learning objectives</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Facilitate reflection on personal takeaways</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Preview next session or follow-up activities</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Collect immediate feedback or plus/delta</span>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-primary mb-3">Post-Course Connection</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Send follow-up resources and materials</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Create online community or discussion forum</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Schedule follow-up check-ins or coaching</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Provide opportunities for peer collaboration</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Offer pathways for continued learning</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Engagement Assessment</h2>
        <div className="space-y-4">
          <h3 className="font-semibold text-lg text-primary mb-3">Indicators of Effective Engagement</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">High participation rates in discussions</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Quality of questions and contributions</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Active collaboration during group work</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Positive body language and energy</span>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Completion of activities and assignments</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Spontaneous connections to personal experience</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Requests for additional resources or follow-up</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Positive feedback and course evaluations</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ResourceLayout
      title="Engagement Checklist"
      description="Comprehensive checklist for creating and maintaining high levels of participant engagement throughout your course"
      content={content}
    />
  );
};

export default EngagementChecklist;